import React from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { RoleList, RoleDeleteModal, RoleCreate, RoleUpdate } from '@app/features/Role';
import { useResourceScreenHelpers } from '@app/hooks';
import { roleApi } from '@app/store';
import { IRole } from '@tickeat/permissions';
import { SettingHeader } from '@app/features/SettingHeader';
import { CheckPermissions } from '@app/components/CheckPermissions';

export const RoleScreen = () => {
  const [readOne, { isFetching }] = roleApi.useLazyReadOneRolesQuery();
  const [deleteOne, { isLoading }] = roleApi.useDeleteOneRolesMutation();

  const {
    triptych,
    modal,
    onDelete,
    onUpdate,
    mode,
    selectedItem,
    item: role,
  } = useResourceScreenHelpers<IRole>();

  const openCard = async (item: Partial<IRole>) => {
    onUpdate(
      readOne({
        filters: { _id: { $eq: item?._id } },
      }),
      item,
    );
  };

  return (
    <MainLayout
      header={
        <SettingHeader>
          <CheckPermissions permissions={['dashboard::roles.create']}>
            <Button onPress={() => triptych.open({ mode: 'CREATE' })} title="Ajouter un rôle" />
          </CheckPermissions>
        </SettingHeader>
      }>
      <RoleDeleteModal
        {...modal}
        onDelete={(role) => onDelete(deleteOne(role._id!))}
        isLoading={isLoading}
      />

      <Triptych
        list={
          <RoleList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard}
            onDelete={modal.open}
          />
        }
        form={
          mode === 'CREATE' ? (
            <RoleCreate />
          ) : (
            <RoleUpdate
              role={role ?? selectedItem}
              toggle={(mode) => (mode === 'UPDATE' ? openCard(selectedItem) : triptych.close())}
              isFetching={isFetching}
              onDelete={modal.open}
            />
          )
        }
      />
    </MainLayout>
  );
};
